/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationEmptyStateContacts = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationEmptyStateContacts"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M20.492 38.15v-6.804h8.418S31.797 1.7 17.218 1.7C1.781 1.7 2.253 16.766 2.253 18.71v19.44zm26.977 11.665v-6.804h-8.418s-2.888-29.646 11.691-29.646c15.438 0 14.966 15.066 14.966 17.01v19.44"
        clipRule="evenodd"
      />
      <path
        fill="#5E737D"
        d="M17.219 1.075c4.82 0 8.096 2.935 10.097 8.049q.517.072 1.037.203l.327.087.277.083.312.107-.445 1.169-.083-.03-.226-.075-.139-.041-.327-.088-.248-.06c.577 1.772 1.024 3.765 1.349 5.952.654 4.407.742 9.074.5 13.33l-.04.642-.078 1.004-.055.564h-8.36v5.62c8.89 2.628 18.717 9.843 29.914 29.333H1.707v-.028l-.001-.084c-.01-.98-.081-8.22-.103-15.613l-.002-.837-.002-.837-.002-1.25v-2.454l.002-.798c.005-2.619.022-5.016.057-6.873h-.028l-.001-19.637c-.006-1.156.028-2.09.166-3.295.203-1.78.594-3.508 1.223-5.135 2.17-5.62 6.717-9.008 14.203-9.008m5.245 3.049c-.74 8.065-10.216 12.469-10.507 12.603l-.007.003H9.523a2.775 2.775 0 0 0 0 5.55s.453-.008.88-.009h.274c.174 0 .321.003.4.009-.183 6.9-6.567 10.18-8.2 10.908v2.986c5.327.028 10.942-.444 16.99 1.076v-4.436l-3.195-2.11h3.424v.017h8.237l.05-.708.019-.323c.237-4.178.15-8.766-.489-13.075-.352-2.37-.846-4.483-1.493-6.31a3 3 0 0 0-.23 0c-1.46.037-2.24.675-2.265 2.291-.024 1.54.406 2.944 1.226 4.503l.12.224.63 1.108a2.29 2.29 0 0 1-1.035 3.22l-.15.062-1.987.742-.437-1.171 1.987-.742c.601-.225.857-.932.537-1.49l-.51-.89-.26-.48c-.91-1.729-1.398-3.325-1.37-5.105.034-2.267 1.306-3.387 3.262-3.513-.906-2.131-2.057-3.798-3.474-4.94m-3.547 19.134c.323.846.843 1.404 1.518 1.742a3.6 3.6 0 0 0 1.637.376l.228-.01.142 1.242-.11.01a4.83 4.83 0 0 1-2.457-.5c-.88-.442-1.582-1.158-2.027-2.174l-.099-.24zm1.22-8.953a.63.63 0 0 1 .623.536l.007.093v.972a.63.63 0 0 1-1.252.093l-.007-.093v-.972a.63.63 0 0 1 .63-.63m6.02 0a.63.63 0 0 1 .622.536l.007.093v.972a.63.63 0 0 1-1.252.093l-.007-.093v-.972a.63.63 0 0 1 .63-.63"
      />
      <path
        fill="#5E737D"
        d="M50.742 12.74c7.485 0 12.033 3.389 14.203 9.008.629 1.627 1.02 3.356 1.223 5.136.118 1.032.16 1.866.165 2.81v20.121h-1.25V41.69h-.027c-.861-.007-8.297-.29-8.494-7.745.078-.005.225-.007.399-.008h.275c.332.001.68.005.818.007l.061.001a2.775 2.775 0 1 0 0-5.549h-2.427s-4.49-2.264-2.043-8.63c-2.792.462-6.97.86-9.46-2.68-.835.992-1.554 2.212-2.162 3.643 1.956.127 3.227 1.247 3.262 3.514.028 1.78-.46 3.376-1.37 5.104l-.261.48-.51.89c-.3.523-.094 1.178.43 1.442l.108.048 1.987.743-.438 1.17-1.986-.742a2.287 2.287 0 0 1-1.185-3.282l.362-.63.268-.478.12-.223c.82-1.559 1.25-2.964 1.225-4.503-.025-1.616-.804-2.254-2.264-2.292h-.23c-.647 1.828-1.142 3.94-1.494 6.311-.64 4.31-.726 8.897-.488 13.075l.038.628.03.402h8.29l.004-.015h3.045l-2.873 1.896v5.55h-1.25v-6.18h-8.36l-.082-.883-.05-.685-.04-.642c-.242-4.256-.154-8.923.5-13.33.325-2.187.771-4.18 1.349-5.951l-.249.059-.326.088-.262.08-.103.035-.084.03-.444-1.168.193-.068.25-.08.303-.086.17-.043a10 10 0 0 1 1.037-.204c2.001-5.113 5.277-8.048 10.097-8.048m-1.698 22.184 1.167.446c-.437 1.144-1.177 1.937-2.125 2.412a4.8 4.8 0 0 1-2.234.508l-.334-.017.143-1.242.045.003a3.63 3.63 0 0 0 1.82-.37c.613-.307 1.099-.795 1.425-1.517zm-1.22-8.954a.63.63 0 0 1 .622.536l.007.093v.972a.63.63 0 0 1-1.252.093l-.007-.093V26.6a.63.63 0 0 1 .63-.63m-6.02 0a.63.63 0 0 1 .622.536l.007.093v.972a.63.63 0 0 1-1.252.093l-.007-.093V26.6a.63.63 0 0 1 .63-.63"
      />
      <path
        fill="#BCC9D1"
        fillRule="evenodd"
        d="M21.42 66.925h44.983V47.831S37.032 39.645 21.42 66.923"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default IllustrationEmptyStateContacts;
